import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
} from './common.js';

export const ExplicitConstructedResponseSelectionsReducer = () => [];

export const ExplicitConstructedResponseSelectionsAggregator = () => [];

export default {
  AggregateMap: GlobalAggregateMap(
    ExplicitConstructedResponseSelectionsAggregator
  ),
  AggregateReduce: GlobalAggregateReduce(
    ExplicitConstructedResponseSelectionsReducer
  ),
};
